export default "__VITE_ASSET__DqYyEHpW__"